/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/link/custom-elements';

import { defineCustomElement as defineOsdsLink } from '@ovhcloud/ods-stencil/components/link/custom-elements/osds-link.js';


export const OsdsLink = /*@__PURE__*/ defineContainer<JSX.OsdsLink>('osds-link', defineOsdsLink, [
  'color',
  'contrasted',
  'disabled',
  'download',
  'href',
  'referrerpolicy',
  'rel',
  'target',
  'type'
]);

